/* =========================================================
REPORT CONFIG
endpoint + export endpoint + HTTP method per report path
========================================================= */

export const getReportConfig = (reportPath) => {
  const configs = {
    "/outstanding-report": {
      reportEndpoint: "/OutstandingReport",
      exportEndpoint: "/OutstandingReportDownload",
      method: "POST",
    },
    "/drg-outlier-report": {
      reportEndpoint: "/Drg_Outliers_Report",
      exportEndpoint: "/Drg_Outliers_Report_Download",
      method: "POST",
    },
    "/hac-report": {
      reportEndpoint: "/Hac_Report",
      exportEndpoint: "/Hac_Report_Download",
      method: "POST",
    },
    "/error-drg-report": {
      reportEndpoint: "/Error_Drg_Report",
      exportEndpoint: "/Error_Drg_Report_Download",
      method: "POST",
    },
    "/codingKpis-Overview": {
      reportEndpoint: null,
      exportEndpoint: null,
      method: "GET",
    },
    "/codingKpis-coder-overview": {
      reportEndpoint: null,
      exportEndpoint: null,
      method: "GET",
    },
    "/coding-kpis-report": {
      reportEndpoint:"/Coding_Stats",
      exportEndpoint: "/Coding_Stats_Download",
      method: "POST",
    },
    "/codingkpis-coder-report":{
      reportEndpoint:"/Coder_Stats",
      exportEndpoint: "/Coder_Stats_Download",
      method: "POST",
    }
  };

  const config = configs[reportPath];
  if (!config) {
    console.warn(`[optionsConfig] No config for path: ${reportPath}`);
  }
  return config || null;
};

export const getColumnFilterEndpoints = (reportPath) => {
  const configs = {
    /* ── Outstanding Report ── */
    "/outstanding-report": {
      episode_identifier: {
        endpoint: "/him_episode_identifier_filters_acs",
        responseKey: "episode_identifier_number",
      },
      patient_id: {
        endpoint: "/OutstandingPatientIdFilter",
        responseKey: "patient_id",
      },
      priority: {
        endpoint: "/him_priority_filters_acs",
        responseKey: "priority",
      },
      speciality: {
        endpoint: "/him_speciality_filters_acs",
        responseKey: "queues.specialities",
      },
      current_queue: {
        endpoint: "/queues_filter",
        responseKey: "queues.queues",
      },
      assign_coder: {
        endpoint: "/him_coders_filters_acs",
        responseKey: "assign_coder",
      },
      status: {
        endpoint: "/him_status_filter_acs",
        responseKey: "status",
      },
      days_of_outstanding: {
        endpoint: "/DaysofOutstandingFilter",
        responseKey: "days_of_outstanding",
      },
    },

    /* ── DRG Outliers Report ── */
    "/drg-outlier-report": {
      priority: {
        endpoint: "/him_priority_filters_acs",
        responseKey: "priority",
      },
      episode_id: {
        endpoint: "/him_episode_identifier_filters_acs",
        responseKey: "episode_identifier_number",
      },
      speciality: {
        endpoint: "/him_speciality_filters_acs",
        responseKey: "queues.specialities",
      },
      status: {
        endpoint: "/him_status_filter_acs",
        responseKey: "status",
      },
      // column key "drg" → filter field "drg_code"
      drg: {
        endpoint: "/DrgFilter",
        responseKey: "drg",
      },
      principal_diagnosis_code: {
        endpoint: "/PrincipalDiagnosisCodeFilter",
        responseKey: "principal_diagnosis_code",
      },
      // column key "drgdescription" → filter field "description"
      description: {
        endpoint: "/DrgDescriptionFilter",
        responseKey: "description",
      },
      // column key "drgavlos" → filter field "alos"
      drgavlos: {
        endpoint: "/DrgAlosFilter",
        responseKey: "drgalos",
      },
      // column key "lowBound" → filter field "lower_bound"
      lower_bound: {
        endpoint: "/LowerBoundFilter",
        responseKey: "lower_bound",
      },
      // column key "UpBound" → filter field "upper_bound"
      upper_bound: {
        endpoint: "/UpperBoundFilter",
        responseKey: "upper_bound",
      },
      codes_assigned: {
        endpoint: "/CodesAssignedFilter",
        responseKey: "codes_assigned",
      },
      revenue: {
        endpoint: "/RevenueFilter",
        responseKey: "revenue",
      },
      nwau: {
        endpoint: "/WeightFilter",
        responseKey: "nwau",
      },
    },

    /* ── HAC Report ── */
    "/hac-report": {
      priority: {
        endpoint: "/him_priority_filters_acs",
        responseKey: "priority",
      },
      episode_id: {
        endpoint: "/him_episode_identifier_filters_acs",
        responseKey: "episode_id",
      },
      speciality: {
        endpoint: "/him_speciality_filters_acs",
        responseKey: "queues.specialities",
      },
      status: {
        endpoint: "/him_status_filter_acs",
        responseKey: "status",
      },
      nwau: {
        endpoint: "/HacNwauFilter",
        responseKey: "nwau",
      },
      revenue_dollar: {
        endpoint: "/HacRevenueFilter",
        responseKey: "revenue_dollar",
      },
      drg: {
        endpoint: "/him_drg_filters_acs",
        responseKey: "drg",
      },
      hac_description: {
        endpoint: "/HacDescriptionFilter",
        responseKey: "hac_description",
      },
      hac_code: {
        endpoint: "/HacCodeFilter",
        responseKey: "hac_code",
      },
      priority: {
        endpoint: "/him_priority_filters_acs",
        responseKey: "priority",
      },
    },

    /* ── Error DRG Report ── */
    "/error-drg-report": {
      priority: {
        endpoint: "/him_priority_filters_acs",
        responseKey: "priority",
      },
      episode_id: {
        endpoint: "/him_episode_identifier_filters_acs",
        responseKey: "episode_identifier_number",
      },
      episode_type: {
        endpoint: "/ErrorDrgEpisodeTypeFilter",
        responseKey: "episode_type",
      },
      speciality: {
        endpoint: "/him_speciality_filters_acs",
        responseKey: "queues.specialities",
      },
      status: {
        endpoint: "/him_status_filter_acs",
        responseKey: "status",
      },
      drg_code: {
        endpoint: "/ErrorDrgCodeFilter",
        responseKey: "drg",
      },
      description: {
        endpoint: "/ErrorDrgDescription",
        responseKey: "drg_description",
      },
      principal_diagnosis: {
        endpoint: "/ErrorDrgPdxFilter",
        responseKey: "principal_diagnosis_code",
      },
      nwau: {
        endpoint: "/ErrorDrgNwauFilter",
        responseKey: "nwau",
      },
      revenue_dollar: {
        endpoint: "/ErrorDrgRevenueFilter",
        responseKey: "dollar_revenue",
      },
    },

    /* ── Coding KPIs ── */
    "/coding-kpis-report": {
       coder: {
        endpoint: "/him_coders_filters_acs",
        responseKey: "users",
      },
      nwau: {
        endpoint: "/average_weight_codingkpi_filter",
        responseKey: "weight",
      },
      site: {
        endpoint: "/organization_filter",
        responseKey: "organization_names",
      },

    },
     "/codingkpis-coder-report": {
     episode_id: {
        endpoint: "/him_episode_identifier_filters_acs",
        responseKey: "episode_id",
      },
      nwau: {
        endpoint: "/average_weight_codingkpi_filter",
        responseKey: "weight",
      },
      site: {
        endpoint: "/organization_filter",
        responseKey: "organization_names",
      },
      speciality: {
        endpoint: "/him_speciality_filters_acs",
        responseKey: "queues.specialities",
      },
       drg: {
        endpoint: "/him_drg_filters_acs",
        responseKey: "drg",
      },
      validation:{
        endpoint: "/episode_type_filter",
        responseKey: "validation_types",
      }
    },
  };

  return configs[reportPath] || {};
};

/* =========================================================
RESPONSE KEY RESOLVER
Resolves a dot-notation key path inside an API response.
e.g. "queues.specialities" → response.queues.specialities
========================================================= */

export const resolveResponseKey = (responseObject, dotPath) => {
  if (!dotPath || !responseObject) return [];
  const keys = dotPath.split(".");
  const result = keys.reduce((current, key) => current?.[key], responseObject);
  return Array.isArray(result) ? result : [];
};
